// #region Imports
import notify from 'devextreme/ui/notify';
import { markRaw } from 'vue';
// #endregion
export default class NotificationFactory {
    // #region Core
    alert(message) {
        alert(message);
    }
    showToast(message, type = "success") {
        if (utils.isNullOrEmpty(message)) {
            return;
        }
        notify({
            message: message,
            width: 500,
            type: type
        });
    }
    closeModal(id) {
        //Vars
        let tWindows = host.store.get("windows").modalWindows;
        //Find
        const index = tWindows.findIndex((v) => v.id === id);
        //Remove
        if (index !== -1) {
            //Remove
            tWindows.splice(index, 1);
            //Scrollbar
            if (tWindows.length === 0) {
                host.pageMeta.scrollbarShow();
            }
        }
    }
    showModal(compontent, componentProps, modalProps = { variant: "popup", position: "center", size: "default" }, modalEvents) {
        // #region Vars
        const id = utils.createId();
        const name = modalProps.name || "__modal_" + id;
        const type = modalProps.variant == "slide" ? "g-modal-slide" : "g-modal-popup";
        const defaults = {};
        // #endregion
        // #region Component
        let tComponent;
        if (utils.isString(compontent)) {
            tComponent = host.components.getComponent(compontent);
        }
        else {
            tComponent = compontent;
        }
        if (!tComponent) {
            return;
        }
        // #endregion
        // #region Optimize
        markRaw(tComponent);
        // #endregion
        // #region Show
        let tWindow = {
            id,
            component: tComponent,
            componentAttrs: { ...defaults, ...componentProps },
            modalEvents,
            windowType: type,
            windowAttrs: { ...modalProps, name, id }
        };
        //Scrollbar
        if (host.store.get("windows").modalWindows.length === 0) {
            host.pageMeta.scrollbarHide();
        }
        //Show
        host.store.get("windows").modalWindows.push(tWindow);
        // #endregion 
    }
    async showModal2(compontent, componentProps, modalProps = { variant: "popup", position: "center", size: "default" }, modalEvents) {
        return new Promise((resolve, reject) => {
            // #region Vars
            const id = utils.createId();
            const name = modalProps.name || "__modal_" + id;
            const type = modalProps.variant == "slide" ? "g-modal-slide" : "g-modal-popup";
            const defaults = {};
            // #endregion
            // #region Component
            let tComponent;
            if (utils.isString(compontent)) {
                tComponent = host.components.getComponent(compontent);
            }
            else {
                tComponent = compontent;
            }
            if (!tComponent) {
                resolve({ state: dialogResultState.Abort });
                return;
            }
            // #endregion
            // #region Optimize
            markRaw(tComponent);
            // #endregion
            // #region Show
            let tWindow = {
                id,
                component: tComponent,
                componentAttrs: { ...defaults, ...componentProps },
                modalEvents,
                windowType: type,
                windowAttrs: { ...modalProps, name, id, type, windowCallback: resolve }
            };
            //Scrollbar
            if (host.store.get("windows").modalWindows.length === 0) {
                host.pageMeta.scrollbarHide();
            }
            //Show
            host.store.get("windows").modalWindows.push(tWindow);
            // #endregion 
        });
    }
    showError(errorObject) {
        if (!errorObject) {
            return;
        }
        if (errorObject instanceof Error) {
            this.showToast(errorObject.message, 'error');
        }
        else {
            this.showToast(utils.getAxiosErrorMessage(errorObject), 'error');
        }
    }
    showQuestion(args) {
        this.showModal("g-messages-question", args, { size: 'default' });
    }
}
